// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__GtGXP","header":"MergedInvoice_header__2ItOu"};